// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__2oNsG","psychics-slug":"Sidebar_psychics-slug__tRYgm","psychics-new-slug":"Sidebar_psychics-new-slug__nGmU3"};